import "./Common.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

function InfoPage() {
  return (
    <div className="main-container">
      <Header />
      <div className="info-content">
        <h1
          style={{ fontSize: "clamp(28px, 5vw, 42px)", marginBottom: "20px" }}
        >
          Open Source VDI - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - <mark>THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!</mark> - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!
        </h1>

        <p>
          Like other IT services, the traditional desktop computer software
          environment is moving to
          <strong> centralized, virtualized, cloud-like infrastructures</strong>
          . It offers an attractive alternative to the administration-intensive
          distributed machine deployment and updating, accompanied with a number
          of benefits.
        </p>

        <p>
          The advantages range from <strong>flexible provisioning</strong>,{" "}
          <strong>simpler administration</strong>,
          <strong> better access control</strong>,{" "}
          <strong>higher security</strong>, and{" "}
          <strong>efficient resource use</strong>
          to supporting <strong>green IT</strong> efforts.
        </p>

        <p>
          The concept goes back to technologies like X11/XDM, LTSP, VNC,
          NoMachineNX, Citrix, and Windows Terminal Server. The modern term for
          this is <strong>Virtual Desktop Infrastructure (VDI)</strong>, with
          solutions like Xen/Citrix, VMware, and open-source platforms like
          ProxMox and OpenStack.
        </p>

        <p>
          Different protocols deliver the desktop environment over LAN/WAN,
          supporting features like remote audio, USB, or drive access depending
          on the technology.
        </p>

        <p>
          <strong>Cloud-based VDI</strong> especially benefits workloads with
          short-lived, discardable resources. Since many machines run similar
          workloads and remain idle often, it's ideal for shared usage models.
        </p>

        <p>
          Use cases include: <strong>educational labs</strong>,{" "}
          <strong>high-performance graphical workstations</strong>,
          <strong>general desktop environments</strong>, and{" "}
          <strong>secure remote visualization in HPC clusters</strong>. VDI
          setups also help secure access to sensitive data in remote
          environments.
        </p>

        <p>
          VDI needs a mix of hardware and software. While commercial vendors
          bundle this, open-source projects combine modular tools. This project
          aims to fill in gaps and improve integration.
        </p>

        <p>
          The goal of this <strong>Desktop-as-a-Service (DaaS)</strong> solution
          is to provide full workstation-like environments in the cloud or on
          hypervisors, avoiding the need to copy large datasets just to view
          them.
        </p>

        <p>
          Users can work remotely with nearly the same experience as a local
          desktop. Even <strong>high-resolution displays</strong>
          are supported with modest bandwidth requirements (e.g., 10 Mbit/s for
          Full HD).
        </p>

        <p>
          Over time, this approach can improve infrastructure use—cloud
          resources can be reused during off-hours, and sensitive data doesn't
          need to leave tightly controlled environments.
        </p>

        <p>
          The project is hosted at the{" "}
          <a
            href="https://www.rz.uni-freiburg.de/en?set_language=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            Computation Center University Freiburg
          </a>
          , and is funded by <strong>bwCloud3</strong> and{" "}
          <strong>NFDI4BIOIMAGE</strong>. It builds on{" "}
          <a
            href="https://www.bwlehrpool.de/"
            target="_blank"
            rel="noopener noreferrer"
          >
            bwLehrpool
          </a>
          .
        </p>

        <p>
          <em>We are just starting something here…</em>
          <br />
          Join our{" "}
          <a
            href="https://matrix.to/#/#opensource-vdi:matrix.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Matrix room
          </a>{" "}
          to get in touch and stay up to date.
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default InfoPage;
